import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA,  } from '@angular/material/dialog';
import { CommonModule, DatePipe, KeyValuePipe, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

import { FseService, FactureSearcher, FacturePreteLot, StateHelper, Virement } from '../fse.service';

import { FormatFSECurrencyPipe, FseToFrDateFormat, IsoDateTransformPipe } from '@app/shared/pipes/format-currency.pipe';
import { DateShortFrPipe } from '@app/fse/fse.pipe';

import * as util from "@app/shared/util";
import * as fselib from 'mercalink-fselib'; 
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-detail-rsp',
  imports: [CommonModule, DateShortFrPipe, FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  templateUrl: './detail-rsp.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./detail-rsp.component.scss', '../fses/fses.component.scss'],
})
export class DetailRspComponent {
  public stateHelper = inject(StateHelper);
  public FseService = inject(FseService);
  public util = util;
  @Input({ required: true }) rsp!: fselib.FseRsp;
  @Input({ required: false }) isRecon: boolean = false;
  public numFacture: string='';                 // Input field used for reconcialiation

  ngOnInit(): void { }

  reconcile() {
    console.log('Reconcile', this.numFacture);
    const data = { 'numFacture':this.numFacture };
    this.FseService.postFseRSPUpdateNumFactureEvent$(environment.server_url, this.rsp.id, data).subscribe((data: any) => {
      console.log('Reconciliation data: ', JSON.stringify(data, null, 2));
    }) ;
  }
}
